

export default {
  methods: {
    $_openSnackbar(options) {
      this.$root.$emit('showSnackbar', options)
    },
    $_closeSnackbar() {
      this.$root.$emit('closeSnackbar')
    }
  }
}
